
export interface PageAdditionalParams extends Record<string, any> {
    back?: () => void;
}

export interface PageAdditionalParamsRef {
    current: PageAdditionalParams;
}

export const pageAdditionalParamsRef: PageAdditionalParamsRef = {
    current: {},
}

export const setPageAdditionalParams = (params: PageAdditionalParams = {}) => {
    pageAdditionalParamsRef.current = params;
}